"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBuyingUrlAndMethod = getBuyingUrlAndMethod;
var AddToBasket = _interopRequireWildcard(require("@ori-events/add-to-basket"));
var _types = require("../types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function getBuyingUrlAndMethod(method) {
  switch (method) {
    case AddToBasket.Method.BUY_FOR_MONEY:
      return {
        url: _types.RequestUrl.AddToBasketForMoney,
        method: AddToBasket.Method.BUY_FOR_MONEY
      };
    case AddToBasket.Method.BUY_FOR_POINTS:
      return {
        url: _types.RequestUrl.AddToBasketForPointsRewardShop,
        method: AddToBasket.Method.BUY_FOR_POINTS
      };
    default:
      return {
        url: _types.RequestUrl.AddToBasketCheckLoyalty,
        method: AddToBasket.Method.BUY_FOR_MONEY
      };
  }
}
